import { refreshClassroomStatus } from '../../../store/slices/selectedActivitySlice';
import { ActivityData } from '../../../interfaces/activity';
import useInterval from '../../../../common/hooks/useInterval';

const useClassroomStatusPolling = (
    pollForClassroomUpdate: boolean,
    activity: ActivityData,
    dispatch,
    pollInterval: number,
) => {
    const activityId = activity?.pk;

    useInterval(
        async () => {
            if (pollForClassroomUpdate) {
                // Patch only backend-owned classroom/vILT fields. Using
                // refreshClassroomStatus (rather than a full getSelectedActivity)
                // ensures the poll never overwrites user-editable fields such as
                // billing_status, class_size, or attended with a possibly-stale
                // read while the user is editing.
                await dispatch(refreshClassroomStatus(activityId));
            }
        },
        pollForClassroomUpdate && activityId ? pollInterval : null,
    );
};

export default useClassroomStatusPolling;
